module.exports = __webpack_public_path__ + "img/revalite.e4aeed74.png";